import { Component } from "react";

import { type IBaseEntity } from "types/apiResponse/apiResponse";
import { type DiscussionsLinkedTypes } from "types/enum";

import { routes } from "utilities/routes";

import { BTLinkRelative } from "commonComponents/btWrappers/BTLink/BTLink";
import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";

export interface IRFILinkResponse extends IBaseEntity {
    linkedType: DiscussionsLinkedTypes;
    rfiCount: number;
    onClick?: () => void;
    readOnly?: boolean;
}

export class RFILinkResponse implements IRFILinkResponse {
    constructor(data: any) {
        this.id = data.id;
        this.linkedType = data.linkedType;
        this.rfiCount = data.rfiCount;
        this.jobId = data.jobId;
        this.builderId = data.builderId;
    }

    linkedType: DiscussionsLinkedTypes;
    rfiCount: number;
    id: number;
    jobId: number | undefined;
    builderId: number;
}

class RFILinkInternal extends Component<IRFILinkResponse> {
    render() {
        const { id, linkedType, builderId, jobId, rfiCount, readOnly } = this.props;

        return (
            <>
                {!readOnly && (
                    <BTLinkRelative
                        to={routes.rfi.getRelatedLink(id, linkedType, builderId, jobId!)}
                        onClick={this.props.onClick}
                    >
                        {rfiCount}
                    </BTLinkRelative>
                )}
                {readOnly && rfiCount}
            </>
        );
    }
}

export const RFILink = withErrorBoundary(RFILinkInternal)("Could not load RFI");
